jQuery(function ($) {
    'use strict';

    // Header Sticky
    $(window).on('scroll',function() {
        if ($(this).scrollTop() > 120){
            $('.navbar-area').addClass("is-sticky");
        }
        else{
            $('.navbar-area').removeClass("is-sticky");
        }
    });

    // Search Popup JS
    $('.close-btn').on('click',function() {
        $('.search-overlay').fadeOut();
        $('.search-btn').show();
        $('.close-btn').removeClass('active');
    });
    $('.search-btn').on('click',function() {
        $(this).hide();
        $('.search-overlay').fadeIn();
        $('.close-btn').addClass('active');
    });

    // Sidebar Modal
    $(".burger-menu").on('click',  function() {
        $('.sidebar-modal').toggleClass('active');
    });
    $(".sidebar-modal-close-btn").on('click',  function() {
        $('.sidebar-modal').removeClass('active');
    });

    // Others Option For Responsive JS
    $(".others-option-for-responsive .dot-menu").on("click", function() {
        $(".others-option-for-responsive .container .container").toggleClass("active");
    });

    // Choose Slider
    $('.choose-slider').owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        smartSpeed: 200,
        margin: 30,
        autoplayHoverPause: true,
        autoplay: true,
        navText: [
            "<i class='las la-arrow-left'></i>",
            "<i class='las la-arrow-right'></i>"
        ],
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 2
            },
            1024: {
                items: 3
            },
            1200: {
                items: 3
            }
        }
    });

    // Testimonial Slider
    $('.testimonial-slider').owlCarousel({
        loop: true,
        nav: true,
        items: 1,
        dots: true,
        smartSpeed: 100,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        margin: 0,
        autoplayHoverPause: true,
        autoplay: true,
        navText: [
            "<i class='las la-arrow-left'></i>",
            "<i class='las la-arrow-right'></i>"
        ],
    });

    // Review Slider
    $('.review-slider').owlCarousel({
        loop: true,
        nav: true,
        items: 1,
        dots: false,
        smartSpeed: 100,
        margin: 0,
        autoplayHoverPause: true,
        autoplay: true,
        navText: [
            "<i class='las la-arrow-left'></i>",
            "<i class='las la-arrow-right'></i>"
        ],
    });

    // Dishes Slider
    $('.dishes-slider').owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        smartSpeed: 200,
        margin: 30,
        autoplayHoverPause: true,
        autoplay: true,
        navText: [
            "<i class='las la-arrow-left'></i>",
            "<i class='las la-arrow-right'></i>"
        ],
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 2
            },
            1024: {
                items: 3
            },
            1200: {
                items: 5
            }
        }
    });

    // Blog Slider
    $('.blog-slider').owlCarousel({
        loop: true,
        nav: true,
        dots: false,
        smartSpeed: 200,
        margin: 10,
        autoplayHoverPause: true,
        autoplay: true,
        navText: [
            "<i class='las la-arrow-left'></i>",
            "<i class='las la-arrow-right'></i>"
        ],
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 2
            },
            1024: {
                items: 3
            },
            1200: {
                items: 3
            }
        }
    });

    // FAQ Accordion
    $(function() {
        $('.accordion').find('.accordion-title').on('click', function(e){
            e.preventDefault();
            // Adds Active Class
            $(this).toggleClass('active');
            // Expand or Collapse This Panel
            $(this).next().slideToggle('fast');
            // Hide The Other Panels
            $('.accordion-content').not($(this).next()).slideUp('fast');
            // Removes Active Class From Other Titles
            $('.accordion-title').not($(this)).removeClass('active');
        });
    });

    // Date Picker JS
    $('#datetimepicker').datepicker({
        weekStart: 0,
        todayBtn: "linked",
        language: "es",
        orientation: "bottom auto",
        keyboardNavigation: false,
        autoclose: true
    });

    // Popup Video
    $('.popup-youtube').magnificPopup({
        disableOn: 320,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });

    // Gallery Popup
    $('.gallery-popup-wrapper').magnificPopup({
        delegate: 'a.gallery-popup',
        type: 'image',
        mainClass: 'mfp-fade',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1]
        },
        removalDelay: 160,
        fixedContentPos: false
    });

    // Nice Select JS
    $('select').niceSelect();

    // Input Plus & Minus Number JS
    $('.input-counter').each(function() {
        var spinner = jQuery(this),
            input = spinner.find('input[type="text"]'),
            btnUp = spinner.find('.plus-btn'),
            btnDown = spinner.find('.minus-btn'),
            min = input.attr('min'),
            max = input.attr('max');

        btnUp.on('click', function() {
            var oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });
        btnDown.on('click', function() {
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - 1;
            }
            spinner.find("input").val(newVal);
            spinner.find("input").trigger("change");
        });
    });

    // Tabs
    (function ($) {
        $('.tab ul.tabs').addClass('active').find('> li:eq(0)').addClass('current');
        $('.tab ul.tabs li a').on('click', function (g) {
            var tab = $(this).closest('.tab'),
                index = $(this).closest('li').index();
            tab.find('ul.tabs > li').removeClass('current');
            $(this).closest('li').addClass('current');
            tab.find('.tab_content').find('div.tabs_item').not('div.tabs_item:eq(' + index + ')').slideUp();
            tab.find('.tab_content').find('div.tabs_item:eq(' + index + ')').slideDown();
            g.preventDefault();
        });
    })(jQuery);

    /*---------------------
    Instagram carousel
--------------------- */
    $('.instagram-carousel').each(function () {
        $(this).find('.single-instagram-post')
            .on('auxclick click', function (e) {
                e.preventDefault();
            })
            .on('middleclick', function (e) {
                window.open($(this).attr('data-permalink'));
            });

        $(this).magnificPopup({
            type: 'image',
            delegate: 'a',
            mainClass: 'mfp-fade',
            gallery: {
                enabled: true,
                navigateByImgClick: false,
            },
            removalDelay: 300,
            preloader: false,
            preload: [0, 0],
            fixedContentPos: false,
            callbacks: {
                buildControls: function() {

                    let dots = $("<div class='mfp-dots'></div>");

                    let popup = this;

                    popup._checkIfClose = function(target) {

                        if($(target).hasClass('mfp-prevent-close')) {
                            return;
                        }

                        let closeOnContent = popup.st.closeOnContentClick;
                        let closeOnBg = popup.st.closeOnBgClick;

                        if(closeOnContent && closeOnBg) {
                            return true;
                        } else {

                            // We don't close the popup if click is on navigation dots
                            if($(target).hasClass('mfp-dots') || $(target).hasClass('mfp-dot')) {
                                return false;
                            }

                            // We close the popup if click is on close button or on preloader. Or if there is no content.
                            if(!popup.content || $(target).hasClass('mfp-close') || (popup.preloader && target === popup.preloader[0]) ) {
                                return true;
                            }

                            // if click is outside the content
                            if(  (target !== popup.content[0] && !$.contains(popup.content[0], target))  ) {
                                if(closeOnBg) {
                                    // last check, if the clicked element is in DOM, (in case it's removed onclick)
                                    if( $.contains(document, target) ) {
                                        return true;
                                    }
                                }
                            } else if(closeOnContent) {
                                return true;
                            }

                        }
                        return false;
                    };

                    let children = Object.values(popup.st.items).slice(0, popup.st.items.length);

                    children.forEach((item, index)  => {
                        dots.append("<button type='button' class='mfp-dot' aria-label='post "+index+"' data-index='"+index+"'></button>");
                    });

                    popup.contentContainer.append(dots);
                },
                open: function () {
                    $('body').addClass('mfp-opened mfp-carousel-opened');
                },
                close: function () {
                    $('body').removeClass('mfp-opened mfp-carousel-opened');
                },
                imageLoadComplete: function () {
                    let popup = this;
                    let currItem = popup.currItem;

                    $(currItem.img).on('click middleclick', function () {
                        window.open(currItem.el.attr('data-permalink'));
                    });

                    popup.contentContainer.append(popup.arrowLeft.add(popup.arrowRight));

                    popup.contentContainer.find(".mfp-dots .mfp-dot").removeClass('mfp-dot-active');
                    popup.contentContainer.find(".mfp-dots .mfp-dot[data-index="+currItem.index+"]").addClass('mfp-dot-active');

                    popup.contentContainer.find(".mfp-dots .mfp-dot").on('click', function () {
                        popup.goTo(Number($(this).attr('data-index')));
                        popup.updateItemHTML();
                    });
                }
            }
        })
    });

    // WOW JS
    $(window).on ('load', function () {
        if ($(".wow").length) {
            var wow = new WOW({
                boxClass:     'wow',      // animated element css class (default is wow)
                animateClass: 'animated', // animation css class (default is animated)
                offset:       20,          // distance to the element when triggering the animation (default is 0)
                mobile:       true, // trigger animations on mobile devices (default is true)
                live:         true,       // act on asynchronously loaded content (default is true)
            });
            wow.init();
        }
    });

}(jQuery));

// function to set a given theme/color-scheme
function setTheme(themeName) {
    localStorage.setItem('vizo_theme', themeName);
    document.documentElement.className = themeName;
}
// function to toggle between light and dark theme
function toggleTheme() {
    if (localStorage.getItem('vizo_theme') === 'theme-dark') {
        setTheme('theme-light');
    } else {
        setTheme('theme-dark');
    }
}
// Immediately invoked function to set the theme on initial load
(function () {
    if (localStorage.getItem('vizo_theme') === 'theme-dark') {
        setTheme('theme-dark');
        document.getElementById('slider').checked = false;
    } else {
        setTheme('theme-light');
        document.getElementById('slider').checked = true;
    }
})();
